import { FormattedNumber } from '@/Domain/Batch/FormattedNumber'

export class SpeciesVolume extends FormattedNumber {}
